import { type CuriosityNamespace, CuriosityValue } from '@procureai/curiosity-ui-mui';
import type { CustomCellRendererProps } from 'ag-grid-react';

export interface CuriosityCellRendererParams {
  ns: CuriosityNamespace;
  fallback?: string;
}

export const CuriosityCellRenderer = ({
  value,
  ns,
  fallback,
}: CustomCellRendererProps<unknown, string | null | undefined> & CuriosityCellRendererParams) => {
  return value ? <CuriosityValue ns={ns} i18nKey={value} fallback={fallback} /> : null;
};
